import { render, staticRenderFns } from "./ApprovalAnswers.vue?vue&type=template&id=5bb7b7b3"
import script from "./ApprovalAnswers.vue?vue&type=script&lang=js"
export * from "./ApprovalAnswers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports